module.exports = __webpack_public_path__ + "img/地砖.c97bc4d2.webp";